var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 12H13V10C13 9.45002 12.55 9.00002 12 9.00002C11.45 9.00002 11 9.45002 11 10V12H9.00001C8.45001 12 8.00001 12.45 8.00001 13C8.00001 13.55 8.45001 14 9.00001 14H11V16C11 16.55 11.45 17 12 17C12.55 17 13 16.55 13 16V14H15C15.55 14 16 13.55 16 13C16 12.45 15.55 12 15 12ZM21.18 5.01002L18.1 2.45002C17.68 2.10002 17.05 2.15002 16.69 2.58002C16.34 3.00002 16.4 3.63002 16.82 3.99002L19.89 6.55002C20.31 6.90002 20.94 6.85002 21.3 6.42002C21.66 6.00002 21.6 5.37002 21.18 5.01002ZM4.10001 6.55002L7.17001 3.99002C7.60001 3.63002 7.66001 3.00002 7.30001 2.58002C6.95001 2.15002 6.32001 2.10002 5.90001 2.45002L2.82001 5.01002C2.40001 5.37002 2.34001 6.00002 2.70001 6.42002C3.05001 6.85002 3.68001 6.90002 4.10001 6.55002ZM12 4.00002C7.03001 4.00002 3.00001 8.03002 3.00001 13C3.00001 17.97 7.03001 22 12 22C16.97 22 21 17.97 21 13C21 8.03002 16.97 4.00002 12 4.00002ZM12 20C8.14001 20 5.00001 16.86 5.00001 13C5.00001 9.14002 8.14001 6.00002 12 6.00002C15.86 6.00002 19 9.14002 19 13C19 16.86 15.86 20 12 20Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.26780c59.svg";
export { ForwardRef as ReactComponent };